<template>
  <div>
    <!-- 自动询货信息设置 -->
    <baseBreadcrumb :page="$t('message.autoInquiryProductMessageSettings')" :menu="$t('message.orderForm')" />
    <div class="body">
      <div class="search">
        <div class="left">
          <div class="item">
            <!-- 客户名/ID -->
            <el-input v-model="datas.search" :placeholder="$t('message.customerID_CustomerName')" />
          </div>
          <!-- 搜索 -->
          <el-button type="primary" @click="search">{{
            $t("message.search")
          }}</el-button>
          <!-- 重置 -->
          <el-button @click="reset">{{
            $t("message.reset")
          }}</el-button>
        </div>
        <div class="right">
          <div class="item">
            <p>如您没单个客户设置消息发送，将默认按照此设置内容进行发送，单个客户需要特别设置的请单独设置</p>
          </div>
          <!-- 自动询货消息设置(默认) -->
          <el-button type="primary" class="primary" @click="$refs.autoAskPrice.dialogVisible = true">{{
            $t("message.defaultSettings")
          }}</el-button>
          <!-- 批量删除设置 -->
          <el-button @click="deleteAll" type="primary" class="dark">{{
            $t("message.batchDeleteSettings")
          }}</el-button>
          <!-- 添加单客户设置 -->
          <el-button type="success" @click="customerMessageSettings">{{
            $t("message.addSingleCustomerSettings")
          }}</el-button>
        </div>
      </div>
      <!-- 列表 -->
      <div class="table">
        <ol>
          <li class="flex05">
            <el-checkbox v-model="checked" @change="handleCheckedChange"></el-checkbox>
          </li>
          <!-- 客户信息 -->
          <li>
            {{ $t("message.userInfo") }}
          </li>
          <!-- 操作人员 -->
          <li>
            {{ $t("message.operatingPersonne") }}
          </li>
          <!-- 客户属性 -->
          <li>
            {{ $t("message.customerProperty") }}
          </li>
          <!-- 消息设置 -->
          <li class="flex5">
            {{ $t("message.messageSettings") }}
          </li>
          <!-- 操作 -->
          <li>
            {{ $t("message.operation") }}
          </li>
        </ol>
        <ul v-for="(item, index) in tableData" :key="index">
          <li class="flex05">
            <el-checkbox v-model="item.checked" @change="handleCheckChange"></el-checkbox>
          </li>
          <!-- 客户信息 -->
          <li>
            <div class="template">
              <!-- 客户名 -->
              <p>{{ $t("message.customerName") }}: {{ item.realname }}</p>
              <!-- 客户ID -->
              <p>{{ $t("message.clientID") }}: {{ item.user_id }}</p>
            </div>
          </li>
          <!-- 操作人员 -->
          <li>
            <div class="template">
              <!-- 业务 -->
              <p>{{ $t("message.business") }}: {{ item.y_admin != null ? item.y_admin.realname : '' }}</p>
              <!--采购  -->
              <p>{{ $t("message.purchase") }}: {{ item.g_admin != null ? item.g_admin.realname : '' }}</p>
              <!-- 配货 -->
              <p>{{ $t("message.distribution") }}: {{ item.p_admin != null ? item.p_admin.realname : '' }}</p>
            </div>
          </li>
          <!-- 客户属性 -->
          <li>
            <div style="width: 100px;">
              <attributeName :name="item.attribute.name" />
            </div>
          </li>
          <!-- 消息设置 -->
          <li class="flex5">
            <div class="template">
              <div class="row" v-for="(setting, index) in item.configs" :key="index">
                <p>{{ setting.type_name }}: {{ setting.message }}</p>
                <span :class="setting.is_enabled == 1 ? 'success' : 'danger'">
                  {{ setting.is_enabled_text }}
                </span>
              </div>
            </div>
          </li>
          <!-- 操作 -->
          <li>
            <div class="template">
              <!-- 修改 -->
              <el-button type="primary" class="primary" @click="editItem(item)" size="mini">{{
                $t("message.edit")
              }}</el-button>
              <!-- 删除 -->
              <el-button type="danger" @click="deleteItem([item.user_id])" class="dark" size="mini">{{
                $t("message.delete")
              }}</el-button>
            </div>
          </li>
        </ul>
      </div>
      <!-- 分页 -->
      <div class="pagination">
        <el-pagination layout="total, sizes, prev, pager, next, jumper" :total="total" :page-sizes="[10, 20, 30, 40]"
          :page-size.sync="datas.pageSize" :current-page.sync="datas.page" @size-change="handleSizeChange"
          @current-change="handleCurrentChange" />
      </div>
    </div>
    <!-- 自动询货消息设置(默认) -->
    <autoAskPrice ref="autoAskPrice" />
    <!-- 客户设置消息 -->
    <customerMessageSettings ref="customerMessageSettings" />

  </div>
</template>
<script>
import autoAskPrice from '../toBePhotographedGoods/components/autoAskPrice.vue'
import customerMessageSettings from './components/customerMessageSettings.vue'
export default {
  components: {
    autoAskPrice,
    customerMessageSettings
  },
  data() {
    return {
      checked: false,
      datas: {
        search: '',
        page: 1,
        pageSize: 10
      },
      tableData: [],
      total: 0,
    };
  },
  created() {
    this.purchaseMessageClientList();
  },
  methods: {
    // 采购询盘消息-客户-列表
    purchaseMessageClientList() {
      this.$api.orderApi.purchaseMessageClientList(this.datas).then(res => {
        res.data.data.forEach(item => {
          item.checked = false;
        })
        this.tableData = res.data.data;
        this.total = res.data.total;
      })
    },
    // 搜索
    search() {
      this.datas.page = 1;
      this.purchaseMessageClientList();
    },
    // 重置
    reset() {
      this.datas.search = '';
      this.search();
    },
    // 分页大小改变
    handleSizeChange(val) {
      this.datas.pageSize = val;
      this.search();
    },
    // 分页当前页改变
    handleCurrentChange(val) {
      this.datas.page = val;
      this.purchaseMessageClientList();
    },
    // 批量删除设置
    deleteAll() {
      let ids = []
      this.tableData.forEach(item => {
        if (item.checked) {
          ids.push(item.user_id);
        }

      })
      if (ids.length == 0) {
        this.$message({
          message: this.$t("message.selectableOperational"),
          type: "error",
        });
        return;
      }
      this.deleteItem(ids);
    },
    // 删除
    deleteItem(ids) {
      this.$confirm('是否删除当前已经选择的客户对应的消息设置，删除后数据不在保留，再次使用需要重新设置，请确认后操作', this.$t("message.hint"), {
        confirmButtonText: this.$t("message.confirm"),
        cancelButtonText: this.$t("message.cancel"),
        type: "warning",
      }).then(() => {
        this.$api.orderApi.purchaseMessageClientBatchDelete({ user_ids: ids }).then(res => {
          this.$message({
            message: res.msg,
            type: "success",
          });
          this.purchaseMessageClientList();
        })
      })
        .catch(() => {

        });
    },
    // 添加单客户设置
    customerMessageSettings() {
      this.$refs.customerMessageSettings.dialogVisible = true;
      this.$refs.customerMessageSettings.user = [];
      this.$refs.customerMessageSettings.clientList = [];
      this.$refs.customerMessageSettings.isAdd = true;
    },
    // 编辑
    editItem(item) {
      this.$refs.customerMessageSettings.user = [item.user_id];
      this.$refs.customerMessageSettings.remarkList = JSON.parse(JSON.stringify(item.configs));
      this.$refs.customerMessageSettings.remarkList.forEach(items => {
        items.is_enabled = items.is_enabled == 1 ? true : false
      })
      this.$refs.customerMessageSettings.isAdd = false;
      this.$refs.customerMessageSettings.dialogVisible = true;
    },
    // 全选/取消全选
    handleCheckedChange(val) {
      this.tableData.forEach(item => {
        item.checked = val;
      })
    },
    // 检查是否有选中项
    handleCheckChange() {
      this.checked = this.tableData.every(item => item.checked);
    }
  },
};
</script>
<style lang='scss' scoped>
.body {
  .search {
    display: flex;
    justify-content: space-between;

    .left,
    .right {
      display: flex;

      .item {
        margin-right: 24px;

        p {
          width: 400px;
          color: red;
        }
      }
    }
  }

  .table {
    margin-top: 24px;

    .flex05 {
      flex: 0.5;
    }

    .flex5 {
      flex: 5;
    }

    .template {
      .row {
        margin-bottom: 12px;

        .success {
          color: #409eff;
        }

        .danger {
          color: #f56c6c;
        }
      }
    }
  }
}
</style>